const contactEnumerators = {
  weightUnit: [
    'pounds',
    'kilograms',
  ],
  gender: [
    'Female',
    'Male',
  ],
};

export default contactEnumerators;
